import { FC, ReactElement } from "react";
import { NavLink } from "react-router-dom";
import { useIsMobile } from "@/common/hooks/useIsMobile";
import { IconProps } from "@/common/icons/types";
import { RouterPath } from "@/router/types";
import { Typography } from "@/shared/ui/Typography";
import { LIGHT_COLOR, LOGO_GRAY } from "@/styles/colorsJS";
import { twCn } from "@/styles/utils";

interface Props {
  to: RouterPath;
  Icon: FC<IconProps>;
  Title: ReactElement;
}

export const MenuNavLink: FC<Props> = ({ to, Icon, Title }) => {
  const isMobile = useIsMobile();
  return (
    <div className="lgc:px-0 lgc:py-0 flex-1 px-2 py-1">
      <NavLink
        to={to}
        className={({ isActive }) =>
          twCn(
            "lgc:flex-row lgc:gap-3 lgc:rounded-sm lgc:px-2",
            "flex-col-gap-1 items-center rounded-lg px-4 py-1",
            "transition-all",
            "hover:bg-brand/15",
            isActive && "bg-brand hover:bg-brand/80",
          )
        }
      >
        {({ isActive }) => (
          <>
            <Icon color={isActive ? LIGHT_COLOR : LOGO_GRAY} />
            <Typography
              type={isMobile ? "caption" : "menu"}
              align="center"
              weight={isActive ? "bold" : "medium"}
              color={isActive ? LIGHT_COLOR : LOGO_GRAY}
            >
              {Title}
            </Typography>
          </>
        )}
      </NavLink>
    </div>
  );
};
